import React from 'react';
import BlazeLink from '../components/BlazeLink';

const getWrappedValueWithLink = (value, link, keyPrefix = '') => {
  if (Array.isArray(value)) {
    const arrayResults = value.map((arrValue, index) => {
      const { keyField, url } = arrValue;
      const keyValue = arrValue[keyField];

      const isLastItem = index === value.length - 1;
      const keyFieldValue = isLastItem ? keyValue : <>{keyValue}, </>;

      return url ? (
        <BlazeLink key={[keyPrefix, index].join('-')} href={url}>
          {<>{keyFieldValue} </>}
        </BlazeLink>
      ) : (
        <>{keyFieldValue} </>
      );
    });

    return arrayResults.length ? arrayResults : null;
  }

  return link ? <BlazeLink href={link}>{value}</BlazeLink> : value;
};

export default getWrappedValueWithLink;
